import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {LoanPartner, NewLoansService} from "../new-loans.service";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";

@Component({
    selector: 'brightside-web-loan-consents',
    templateUrl: './loan-consents.component.html',
    styleUrls: ['./loan-consents.component.css'],
    standalone: false
})
export class LoanConsentsComponent implements OnInit {

  loanPartnerInfo: Observable<LoanPartner> = this.newLoanSvc.partnerInfo;
  showConsents = true;

  constructor(
    private newLoanSvc: NewLoansService,
    private faCreateSvc: FinancialAccountsCreationService,
    ) { }

  ngOnInit(): void {
    this.newLoanSvc.getLoanByPartnerType().subscribe();
  }

  termsAccepted($event: boolean) {
    this.faCreateSvc.advanceStep(AccountCreationSteps.CONSENTS);
    this.showConsents = false;
    this.newLoanSvc.postLoan();
  }
}
